"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TrainComposition = function TrainComposition(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 0a12 12 0 1 0 12 12 12 12 0 0 0 -12-12z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.93 10.63-.55-.55a3.1 3.1 0 0 0 -4.4 0l-3.58 3.57a3.12 3.12 0 0 0 0 4.4l.6.55a3.11 3.11 0 0 0 4.4 0l1.6-1.69a.78.78 0 0 0 -1.1-1.1l-1.65 1.69a1.59 1.59 0 0 1 -2.2 0l-.55-.5a1.57 1.57 0 0 1 0-2.2l3.58-3.57a1.59 1.59 0 0 1 2.2 0l.55.55a.78.78 0 0 0 1.1-1.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.6 6-.55-.55a3.11 3.11 0 0 0 -4.4 0l-1.54 1.49a.78.78 0 1 0 1.1 1.06l1.54-1.5a1.59 1.59 0 0 1 2.2 0l.55.55a1.55 1.55 0 0 1 0 2.2l-3.57 3.57a1.59 1.59 0 0 1 -2.2 0 .78.78 0 0 0 -1.1 0 .77.77 0 0 0 0 1.1 3.1 3.1 0 0 0 4.4 0l3.57-3.57a3.12 3.12 0 0 0 0-4.35z"
  })));
};

var _default = TrainComposition;
exports["default"] = _default;